import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-python.min.js';
import 'prismjs/components/prism-java.min.js';
import 'prismjs/components/prism-bash.min.js';
import { CodeViewerModel } from "./code-viewer.model";

@Component({
    selector: 'app-code-viewer',
    templateUrl: './code-viewer.component.html',
    styleUrls: ['./code-viewer.component.scss']
})
export class CodeViewerComponent implements OnInit, AfterViewInit {
    @Input({required: true}) text!: string;
    textBlocks: CodeViewerModel[] = [];

    ngOnInit() {
        this.textBlocks = this.text.split('|').map(e => {
            let value = e;
            let type: 'text' | 'code' = 'text';
            let language;

            if (value.startsWith('[code]')) {
                try {
                    type = 'code';
                    value = value.replace('[code]', '');
                    language = value.split(']')[0].replace('[', '');
                    value = value.split(']')[1];
                } catch (_) {
                    console.warn('Wrong format, backup using text mode');
                    return {value: e, type: 'text'};
                }
            }

            return {value, type, language}
        });
    }

    ngAfterViewInit() {
        Prism.highlightAll();
    }
}